import React from 'react'
import PropTypes from 'prop-types'

const TextInputField = ({
  label = '',
  name,
  text,
  type = 'text',
  errorText = '',
  showError = false,
  onChange,
  ...rest
}) => {
  const inputClassName = `field field--important field--outlined ${showError && errorText !== '' ? 'error-field' : ''}`

  return (
    <div className="input-container">
      {label && (
        <label>
          {`${label}:`}
        </label>
      )}
      <input
        className={inputClassName}
        type={type}
        name={name}
        value={text}
        onChange={onChange}
        {...rest}
      />
      { showError ? (
        <div className="error-message">
          <span className="text">{errorText}</span>
        </div>
      ) : null
      }
    </div>
  )
}

TextInputField.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  text: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  showError: PropTypes.bool,
  errorText: PropTypes.string,
  type: PropTypes.string,
}

export default TextInputField
